import { useEffect, useRef, useState } from 'react';

const easeOutQuad = (t) => t * (2 - t);

const Counter = ({ end = 0, decimals = 0, duration = 1500 }) => {
    const [value, setValue] = useState(0);
    const frameRef = useRef(null);
    const startRef = useRef(null);
    const hasStartedRef = useRef(false);
    const nodeRef = useRef(null);

    useEffect(() => {
        const node = nodeRef.current;
        if (!node) {
            return undefined;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                if (entry.isIntersecting && !hasStartedRef.current) {
                    hasStartedRef.current = true;
                    startRef.current = null;
                    const animate = (timestamp) => {
                        if (!startRef.current) {
                            startRef.current = timestamp;
                        }
                        const progress = Math.min((timestamp - startRef.current) / duration, 1);
                        const eased = easeOutQuad(progress);
                        const nextValue = end * eased;
                        setValue(progress < 1 ? nextValue : end);
                        if (progress < 1) {
                            frameRef.current = requestAnimationFrame(animate);
                        }
                    };
                    frameRef.current = requestAnimationFrame(animate);
                }
            },
            { threshold: 0.3 }
        );

        observer.observe(node);

        return () => {
            if (frameRef.current) {
                cancelAnimationFrame(frameRef.current);
            }
            observer.disconnect();
        };
    }, [duration, end]);

    return (
        <span ref={nodeRef} className="count-element">
            {value.toFixed(decimals)}
        </span>
    );
};

export default Counter;
